function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.36,5.5,3.61.252a1.75,1.75,0,0,0-2.651,1.5v10.5a1.75,1.75,0,0,0,2.651,1.5L12.36,8.5A1.75,1.75,0,0,0,12.36,5.5Z",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/play.bc762ba4.svg";
export { SvgComponent as ReactComponent };